import {
  archiveInvitationFlowApiCall,
  completeCustomerInvitationFlowApiCall,
  createInvitationFlowApiCall,
  getCustomerInvitationFlowApiCall,
  getFlowSignatureUploadUrlApiCall,
  getProviderCustomersInvitationFlowsApiCall,
  getProviderInvitationFlowsApiCall,
  removeDefaultInvitationFlowApiCall,
  sendInvitationFlowApiCall,
  setDefaultInvitationFlowApiCall,
  updateCustomerDataFromInvitationFlowApiCall,
  updateCustomerFlowOwnerStatusApiCall,
  updateInvitationFlowApiCall,
} from '@guryou/api-client-gql';

import { resetState } from '../actions';
import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const GET_PROVIDER_INVITATION_FLOWS = { entity: 'GET_PROVIDER_INVITATION_FLOWS', action: Action.GET_MANY };
export const GET_PROVIDER_CUSTOMERS_INVITATION_FLOWS = { entity: 'GET_PROVIDER_CUSTOMERS_INVITATION_FLOWS', action: Action.GET_MANY };
export const CREATE_INVITATION_FLOW = { entity: 'CREATE_INVITATION_FLOW', action: Action.CREATE };
export const UPDATE_INVITATION_FLOW = { entity: 'UPDATE_INVITATION_FLOW', action: Action.UPDATE };
export const UPDATE_CUSTOMER_FLOW_OWNER_STATUS = { entity: 'UPDATE_CUSTOMER_FLOW_OWNER_STATUS', action: Action.UPDATE };
export const SET_DEFAULT_INVITATION_FLOW = { entity: 'SET_DEFAULT_INVITATION_FLOW', action: Action.UPDATE };
export const REMOVE_DEFAULT_INVITATION_FLOW = { entity: 'REMOVE_DEFAULT_INVITATION_FLOW', action: Action.UPDATE };
export const DELETE_INVITATION_FLOW = { entity: 'DELETE_INVITATION_FLOW', action: Action.DELETE };
export const GET_CUSTOMER_INVITATION_FLOW = { entity: 'GET_CUSTOMER_INVITATION_FLOW', action: Action.GET_ONE };
export const SEND_INVITATION_FLOW = { entity: 'SEND_INVITATION_FLOW', action: Action.HANDLE };

export const UPDATE_CUSTOMER_FROM_INVITATION_FLOW = { entity: 'UPDATE_CUSTOMER_FROM_INVITATION_FLOW', action: Action.UPDATE };
export const COMPLETE_CUSTOMER_INVITATION_FLOW = { entity: 'COMPLETE_CUSTOMER_INVITATION_FLOW', action: Action.UPDATE };
export const GET_FLOW_SIGNATURE_UPLOAD_URL = { entity: 'GET_FLOW_SIGNATURE_UPLOAD_URL', action: Action.HANDLE };

export const getInvitationFlows = () => async dispatch =>
  execute(dispatch, () => getProviderInvitationFlowsApiCall(), GET_PROVIDER_INVITATION_FLOWS, false, true);

export const getProviderCustomersInvitationFlows = () => async dispatch =>
  execute(dispatch, () => getProviderCustomersInvitationFlowsApiCall(), GET_PROVIDER_CUSTOMERS_INVITATION_FLOWS, false, true);

export const updateCustomerFlowOwnerStatus = (customerFlowId, status, rejectionType, rejectionReason) => async dispatch =>
  execute(
    dispatch,
    () => updateCustomerFlowOwnerStatusApiCall({ customerFlowId, status, rejectionType, rejectionReason }),
    UPDATE_CUSTOMER_FLOW_OWNER_STATUS
  );

export const createFlow = request => async dispatch => execute(dispatch, () => createInvitationFlowApiCall({ request }), CREATE_INVITATION_FLOW);
export const updateFlow = request => async dispatch => execute(dispatch, () => updateInvitationFlowApiCall({ request }), UPDATE_INVITATION_FLOW);

export const setDefaultFlow = id => async dispatch => execute(dispatch, () => setDefaultInvitationFlowApiCall({ id }), SET_DEFAULT_INVITATION_FLOW);

export const removeDefaultFlow = () => async dispatch =>
  execute(dispatch, () => removeDefaultInvitationFlowApiCall(), REMOVE_DEFAULT_INVITATION_FLOW);

export const archiveFlow = id => async dispatch => execute(dispatch, () => archiveInvitationFlowApiCall({ id }), DELETE_INVITATION_FLOW);

export const getCustomerInvitationFlow = customerFlowId => async dispatch =>
  execute(dispatch, () => getCustomerInvitationFlowApiCall({ customerFlowId }), GET_CUSTOMER_INVITATION_FLOW, false);

export const completeCustomerInvitationFlow = customerFlowId => async dispatch =>
  execute(dispatch, () => completeCustomerInvitationFlowApiCall({ customerFlowId }), COMPLETE_CUSTOMER_INVITATION_FLOW, false);

export const updateCustomerDataFromInvitationFlow = request => async dispatch =>
  execute(dispatch, () => updateCustomerDataFromInvitationFlowApiCall({ request }), UPDATE_CUSTOMER_FROM_INVITATION_FLOW);

export const getFlowSignatureUploadUrl = request => async dispatch =>
  execute(dispatch, () => getFlowSignatureUploadUrlApiCall({ request }), GET_FLOW_SIGNATURE_UPLOAD_URL);

export const sendInvitationFlowToUser = (userId, flowId) => async dispatch =>
  execute(dispatch, () => sendInvitationFlowApiCall({ userId: +userId, flowId }), SEND_INVITATION_FLOW, true);

export const resetCreateUpdateFlowState = () => async dispatch => {
  dispatch(resetState(CREATE_INVITATION_FLOW));
  dispatch(resetState(UPDATE_INVITATION_FLOW));
};

export const customersInvitationFlowReducers = {
  all: basicReducer(GET_PROVIDER_INVITATION_FLOWS),
  customersFlows: basicReducer(GET_PROVIDER_CUSTOMERS_INVITATION_FLOWS),
  create: basicReducer(CREATE_INVITATION_FLOW),
  update: basicReducer(UPDATE_INVITATION_FLOW),
  archive: basicReducer(DELETE_INVITATION_FLOW),

  updateCustomerFlowOwnerStatus: basicReducer(UPDATE_CUSTOMER_FLOW_OWNER_STATUS),

  updateCustomerDataFromFlow: basicReducer(UPDATE_CUSTOMER_FROM_INVITATION_FLOW),
  getFlowSignatureUploadUrl: basicReducer(GET_FLOW_SIGNATURE_UPLOAD_URL),
  customerInvitationFlow: basicReducer(GET_CUSTOMER_INVITATION_FLOW),
  setDefault: basicReducer(SET_DEFAULT_INVITATION_FLOW),
  removeDefault: basicReducer(REMOVE_DEFAULT_INVITATION_FLOW),

  sendFlow: basicReducer(SEND_INVITATION_FLOW),
};
